module.exports = __webpack_public_path__ + "img/Billedbog_Norsk_Billedbog_for_Boern.3c2ef76e.jpg";